<!--
물품가비용 과금 모달 컴포넌트
------------------------------------
사용: app.$refs['charge-goods-cost'].form(prodId, userId, prodInfo)
TASK-025: 추가비용과 유사하나 항상 예치금 결제 (카드수수료 없음)
TASK-176 v3: 환불 토글 제거 — charge_type '1' 고정 (서버도 1 만 허용)
-->
<template>
    <div class="uk-flex-top" uk-modal esc-close="false" bg-close="false">
        <div class="uk-modal-dialog uk-margin-auto-vertical" style="width: 640px">

            <div class="uk-modal-header">
                <h4 class="uk-text-center" style="margin: 0;">물품가비용 과금</h4>
            </div>

            <div class="uk-modal-body" style="padding: 24px 30px;">

                <!-- 예치금 결제 안내 -->
                <div style="background: #fffbeb; border: 1px solid #fcd34d; border-radius: 8px; padding: 12px 16px; margin-bottom: 20px; color: #78350f; line-height: 1.6; font-size: 0.9rem;">
                    물품가비용은 주결제수단에 관계없이 <strong>항상 예치금</strong>으로 결제됩니다.
                </div>

                <!-- 상품 정보 카드 -->
                <div v-if="prod.id"
                     style="background: #f8fafc; border: 1px solid #edf2f7; border-radius: 10px; padding: 18px 20px; margin-bottom: 16px;">
                    <div style="font-weight: 600; color: #718096; margin-bottom: 14px; padding-bottom: 10px; border-bottom: 1px solid #edf2f7;">
                        상품 정보
                    </div>
                    <div class="uk-grid uk-grid-small uk-child-width-1-2" uk-grid>
                        <div>
                            <app-column header="상품번호" header-size="medium" body-size="medium"
                                header-align="left" body-align="left" horizontal header-width="70px">
                                {{ prod.id }}
                            </app-column>
                        </div>
                        <div>
                            <app-column header="배송코드" header-size="medium" body-size="medium"
                                header-align="left" body-align="left" horizontal header-width="70px">
                                {{ prod.house_code || '-' }}
                            </app-column>
                        </div>
                        <div>
                            <app-column header="수취인" header-size="medium" body-size="medium"
                                header-align="left" body-align="left" horizontal header-width="70px">
                                {{ prod.house_name || '-' }}
                            </app-column>
                        </div>
                        <div>
                            <app-column header="송장번호" header-size="medium" body-size="medium"
                                header-align="left" body-align="left" horizontal header-width="70px">
                                {{ prod.blno || '-' }}
                            </app-column>
                        </div>
                    </div>
                </div>

                <!-- 회원 정보 카드 -->
                <div v-if="member.nick"
                     style="background: #f8fafc; border: 1px solid #edf2f7; border-radius: 10px; padding: 18px 20px; margin-bottom: 24px;">
                    <div style="font-weight: 600; color: #718096; margin-bottom: 14px; padding-bottom: 10px; border-bottom: 1px solid #edf2f7;">
                        회원 정보
                    </div>
                    <div class="uk-grid uk-grid-small uk-child-width-1-2" uk-grid>
                        <div>
                            <app-column header="회원사" header-size="medium" body-size="medium"
                                header-align="left" body-align="left" horizontal header-width="70px">
                                {{ member.nick }}
                            </app-column>
                        </div>
                        <div>
                            <app-column header="결제수단" header-size="medium" body-size="medium"
                                header-align="left" body-align="left" horizontal header-width="70px">
                                <span style="display: inline-flex; align-items: center; gap: 6px; background: #fffbeb; border: 1px solid #fcd34d; border-radius: 6px; padding: 2px 10px; font-size: 0.9rem;">
                                    <span style="width: 7px; height: 7px; border-radius: 50%; background: #d97706; flex-shrink: 0;"></span>
                                    <span>예치금 (강제)</span>
                                </span>
                            </app-column>
                        </div>
                    </div>
                </div>

                <!-- 과금 정보 섹션 -->
                <div style="font-weight: 600; color: #4a5568; margin-bottom: 16px; padding-bottom: 10px; border-bottom: 2px solid #edf2f7;">
                    <span>과금 정보</span>
                </div>

                <!-- 안내 -->
                <div style="background: #ebf8ff; border: 1px solid #90cdf4; border-radius: 8px; padding: 12px 16px; margin-bottom: 20px; color: #2a4365; line-height: 1.6; font-size: 0.9rem;">
                    물품 원가(상품가, 구매대행비 등)를 과금할 때 사용합니다.<br>
                    운임정산에 포함되지 않으며, 예치금에서 즉시 차감됩니다.<br>
                    한 상품에 물품가 과금은 1건 — 잘못 과금했으면 과금내역에서 과금 취소 후 다시 과금하세요.
                </div>

                <!-- 금액 -->
                <div class="uk-margin">
                    <label class="uk-form-label">과금 금액 (원)</label>
                    <div class="uk-form-controls">
                        <input class="uk-input" type="text"
                               v-model="inputs.price"
                               @input="onPriceInput"
                               placeholder="이 금액이 예치금에서 차감됩니다">
                    </div>
                </div>

                <!-- 비고 -->
                <div class="uk-margin">
                    <label class="uk-form-label">비고</label>
                    <div class="uk-form-controls">
                        <textarea class="uk-textarea" rows="3"
                                  v-model="inputs.memo"
                                  placeholder="과금 사유를 입력하세요"></textarea>
                    </div>
                </div>

                <!-- 결제 요약 -->
                <div v-if="price > 0"
                     style="border-radius: 10px; padding: 18px 20px; margin-top: 20px; border: 1px solid #e2e8f0; background: #fffbeb;">
                    <div style="font-weight: 600; margin-bottom: 14px; padding-bottom: 10px; border-bottom: 1px solid #e2e8f0;">
                        <span>결제 요약</span>
                    </div>
                    <div class="uk-flex uk-flex-between" style="padding: 6px 0; color: #718096;">
                        <span>과금금액</span>
                        <span style="color: #2d3748; font-weight: 500;">{{ numberFormat(price) }} 원</span>
                    </div>
                    <div class="uk-flex uk-flex-between" style="padding: 6px 0; color: #718096; font-size: 0.9rem;">
                        <span>결제수단</span>
                        <span style="color: #d97706; font-weight: 500;">예치금</span>
                    </div>
                    <div class="uk-flex uk-flex-between"
                         style="border-top: 2px solid #fcd34d; margin-top: 10px; padding-top: 12px; font-weight: 700; font-size: 1.1rem;">
                        <span>최종 결제금액</span>
                        <span style="color: #d97706;">{{ numberFormat(price) }} 원</span>
                    </div>
                </div>

                <!-- 에러 메시지 -->
                <div v-if="errorMsg" class="uk-alert uk-alert-danger" style="margin-top: 16px;">
                    {{ errorMsg }}
                </div>
            </div>

            <div class="uk-modal-footer uk-text-right">
                <button type="button"
                        class="uk-button uk-button-default uk-modal-close">
                    <span uk-icon="icon: close"></span> 취소
                </button>
                <button type="button"
                        class="uk-button"
                        style="background: #d97706; color: #fff; border: 1px solid #d97706;"
                        :disabled="submitting"
                        @click="submit()">
                    <span uk-icon="icon: check"></span>
                    과금 실행
                </button>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            csrfToken: String,
        },
        data: function () {
            return {
                member: {},
                prod: {},
                prodId: null,
                userId: null,
                inputs: {
                    price: '',
                    memo: '',
                },
                price: 0,
                errorMsg: '',
                submitting: false,
            };
        },
        methods: {
            form: function (prod_id, user_id, prod_info) {
                this.prodId = prod_id;
                this.userId = user_id;
                this.prod = prod_info || {};
                this.inputs = { price: '', memo: '' };
                this.price = 0;
                this.member = {};
                this.errorMsg = '';
                this.submitting = false;

                var self = this;
                $.app.ajax.module.background({
                    type: 'get',
                    url: '/company-users/' + user_id,
                    contentType: 'application/json',
                    data: {},
                    success: function (response) {
                        self.member = {
                            nick: response.user.nick,
                        };
                        UIkit.modal(self.$el).show();
                    },
                });
            },

            onPriceInput: function () {
                this.price = parseInt(this.inputs.price) || 0;
            },

            submit: function () {
                if (this.price < 1) {
                    this.errorMsg = '과금 금액은 최소 1원 이상이어야 합니다.';
                    return;
                }

                this.errorMsg = '';
                this.submitting = true;

                var self = this;
                var load = new Promise(function (resolve, reject) {
                    $.app.ajax.module.default({
                        type: 'post',
                        url: '/prods/' + self.prodId + '/goods-costs',
                        data: {
                            '_token': self.csrfToken,
                            'charge_type': '1',
                            'price': self.inputs.price,
                            'memo': self.inputs.memo,
                        },
                        success: function (response) { resolve(response); },
                        error: function (jqXHR) { reject(jqXHR); },
                    });
                });

                load.then(function (response) {
                    UIkit.modal(self.$el).hide();
                    UIkit.modal.alert(response.msg).then(function () {
                        $.app.refresh();
                    });
                }).catch(function (jqXHR) {
                    self.submitting = false;

                    if (jqXHR.status === 422 && jqXHR.responseJSON) {
                        var errors = jqXHR.responseJSON;
                        var msgs = [];
                        for (var field in errors) {
                            if (Array.isArray(errors[field])) {
                                msgs.push(errors[field][0]);
                            }
                        }
                        self.errorMsg = msgs.join('\n') || '입력값을 확인하세요.';
                    } else if (jqXHR.responseJSON && jqXHR.responseJSON.msg) {
                        self.errorMsg = jqXHR.responseJSON.msg;
                    } else if (jqXHR.status === 0) {
                        self.errorMsg = '서버와 통신할 수 없습니다. 네트워크 연결, 브라우저 확장 프로그램(광고차단 등), 프록시 설정을 확인해 주세요.';
                    } else if (jqXHR.status === 419) {
                        self.errorMsg = '세션이 만료되었습니다. 페이지를 새로고침(F5) 후 다시 시도해 주세요.';
                    } else {
                        self.errorMsg = '요청 처리 중 오류가 발생했습니다. (HTTP ' + jqXHR.status + ')';
                    }
                });
            },

            numberFormat: function (num) {
                return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
            },
        },
    };
</script>
